import { dataHooks } from '../../../../../libs/dataHooks';

export const infoPanelDataHooks = dataHooks<{
  goodForTitle;
  goodFor;
  descriptionTitle;
  description;
  hideInfoLabel;
}>('info-panel');
